import { Component } from '@angular/core';

@Component({
  selector: 'app-fines',
  templateUrl: './fines.component.html',
  styleUrl: './fines.component.css',
})
export class FinesComponent {}
